import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BehaviorService {

  public showSideNav = new BehaviorSubject<boolean>(false);
  public apiRequest = new BehaviorSubject<string>(null);
  public popup = new BehaviorSubject<{
    extraData?: any,
    pop:
    'no-credits' |
    'unsubscribe' |
    'portal-info' |
    'pass-changed' |
    'success-topup' |
    'error-generic' |
    'access-account' |
    'validate-email' |
    'redeem-success' |
    'error-subscription' |
    'success-subscription' |
    'no-credits-subscription' |
    'subscription-processing' |
    'card-payment-error' |
    'operator-payment-error' |
    'card-update-success' |
    'failed-payment' |
    'wallet-welcome' |
    'custom'
  }>(null);
  /* 'active-notif' | */

  public toast = new BehaviorSubject<{ type: 'success' | 'error' | 'warn' | 'info', description: string, time?: number }>(null);

  public sliderCallResp = new BehaviorSubject<any>(null);
  public categoriesCallResp = new BehaviorSubject<any>(null);
  public contentCallResp = new BehaviorSubject<any>(null);
  public mainContentCallResp = new BehaviorSubject<any>(null);
  public eligibilityCallResp = new BehaviorSubject<any>(null);
  public subscriptionCallResp = new BehaviorSubject<any>(null);
  public uparInfoCmsCallResp = new BehaviorSubject<any>(null);
  public tournamentsCallResp = new BehaviorSubject<any>(null);

  public portalLangs = new BehaviorSubject<string[]>(['en']);
  public propConfs = new BehaviorSubject<any>(null);
  public paymentData = new BehaviorSubject<any>(null);
  public voucherData = new BehaviorSubject<{ selected: any, voucher: any }>(null);
  public initialCmsSetts = new BehaviorSubject<any>(null);

  public AccountCallResp_ = new BehaviorSubject<any>(null);
  public UserAccount = new BehaviorSubject<any>({});
  public UserWallet = new BehaviorSubject<any>({});
  public UserSubscription = new BehaviorSubject<any>({});

}